import React, { useEffect, useState } from "react";
import { API } from "@/lib/api";

export default function TopBar() {
  const [text, setText] = useState(
    "Canton Fair Autumn 2026 · Buyer cohorts · Free sourcing consultation"
  );
  useEffect(() => {
    fetch(`${API}/settings`)
      .then((r) => r.json())
      .then((d) => d.ticker && setText(d.ticker))
      .catch(() => {});
  }, []);
  return (
    <div className="topbar" data-testid="top-ticker">
      {text.replace(/[\u{1F300}-\u{1FAFF}]/gu, "").trim()}
    </div>
  );
}
